import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { TekWissenCertificate } from './TekWissenCertificate';
import { ScaledCertificate } from './ScaledCertificate';
import { downloadCertificatePdf } from './certificatePdf';

const safeName = (s) => String(s || 'certificate').replace(/[^A-Za-z0-9_-]+/g, '_');

// Certificate on screen + one-click PDF download (rendered off-screen at full size for a crisp file)
export const CertificateView = ({ data, actions = null }) => {
  const exportRef = useRef(null);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (!exporting) return;
    let live = true;
    downloadCertificatePdf(exportRef.current, `TekWissen_Certificate_${safeName(data.credentialId)}.pdf`)
      .then(() => toast.success('Certificate downloaded'))
      .catch(() => toast.error('Could not create the PDF. Please try again.'))
      .finally(() => live && setExporting(false));
    return () => { live = false; };
  }, [exporting, data.credentialId]);

  return (
    <div className="space-y-5" data-testid="certificate-view">
      <div className="flex flex-wrap items-center justify-end gap-2">
        {actions}
        <Button onClick={() => setExporting(true)} disabled={exporting} className="bg-[#0891b2] text-white hover:bg-[#0e7490]" data-testid="certificate-download-pdf-btn">
          {exporting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Download className="mr-2 h-4 w-4" />}
          {exporting ? 'Preparing PDF...' : 'Download PDF'}
        </Button>
      </div>
      <ScaledCertificate><TekWissenCertificate data={data} /></ScaledCertificate>
      {exporting && createPortal(
        <div aria-hidden="true" style={{ position: 'fixed', left: -20000, top: 0, pointerEvents: 'none' }}>
          <TekWissenCertificate ref={exportRef} data={data} />
        </div>,
        document.body,
      )}
    </div>
  );
};
